export default {
  state: {
    appName: 'Docpool'
  },
  mutations: {
    setAppName (state, payload) {
      state.appName = payload
    }
  },
  getters: {
    getAppName (state) {
      return state.appName
    }
  }
}
